/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ProvinciaDepartamentoIdDepartamentGet$Params {
  idDepartament: string;
}


export function provinciaDepartamentoIdDepartamentGet(
  http: HttpClient,
  rootUrl: string,
  params?: ProvinciaDepartamentoIdDepartamentGet$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, provinciaDepartamentoIdDepartamentGet.PATH, 'get');

  if (params?.idDepartament) {
    rb.path('idDepartament', params.idDepartament, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}


provinciaDepartamentoIdDepartamentGet.PATH = '/provincia/departamento/{idDepartament}';
